import styled, { keyframes } from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const bounce = keyframes(["0%,80%,100%{transform:scale(0);}40%{transform:scale(1);}"]);
const Dot = styled.span.withConfig({
  displayName: "LoadingDotsIcon__Dot"
})(["display:inline-block;width:4px;height:4px;border-radius:50%;background:currentColor;animation:", " 1.4s infinite ease-in-out both;&:nth-child(1){animation-delay:-0.32s;}&:nth-child(2){animation-delay:-0.16s;}"], bounce);
export function LoadingDotsIcon() {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    blockSize: "16px",
    display: "inline-flex",
    children: [/*#__PURE__*/_jsx(Dot, {}), /*#__PURE__*/_jsx(Dot, {}), /*#__PURE__*/_jsx(Dot, {})]
  });
}